import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyStep = _resolveComponent("VJoyStep")!
  const _component_VJoyStepper = _resolveComponent("VJoyStepper")!

  return (_openBlock(), _createBlock(_component_VJoyStepper, {
    step: _ctx.currentStepNumber,
    "sub-step": _ctx.currentSubStepNumber
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VJoyStep, { "sub-steps": 4 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.progress-tracker.freelancer')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_VJoyStep, { "sub-steps": 2 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.progress-tracker.conditions')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_VJoyStep, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.progress-tracker.mission')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_VJoyStep, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.progress-tracker.preview')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["step", "sub-step"]))
}